import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";
 
const notificationApi = {
  getNotificationsAdHoc: (payload) => {
    const url = "quickapp/v1/store-communication/app-notification/search";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      silent: true,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
 
  markNotificationAsSeenAdhoc: (id) => {
    const url = `quickapp/v1/store-communication/app-notification/markAsSeen?id=${id}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      silent: true,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
  chatTickets: (payload) => {
    const url = "quickapp/v1/ticket/search";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      silent: true,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
  getNotificationsquickapp: (payload) => {
    const url = "quickapp/v1/app-notifications/search";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      silent: true,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
  markNotificationAsSeenquickapp: (id) => {
    const url = `quickapp/v1/app-notifications/markAsSeen?id=${id}`;
    return request({
      method: HTTP_METHOD.GET,
      url,
      silent: true,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
  getSiteDetails: (id) => {
    const url = "quickapp/v1/user/site-detail";
    return request({
      method: HTTP_METHOD.GET,
      url,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
  getSelPrintingStatus: () => {
    const url = "v1/sel/getSelPrintingStatus";
    return request({
      method: HTTP_METHOD.GET,
      url,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
};
 
export default notificationApi;
